<template>
  <div class="third-order-template" v-if="detail.orderSource === 2">
    <div class="title-box">
      <el-image :src="cheImage" class="title-label"></el-image>
      第三方订单信息
    </div>
    <div class="list-box">
      <div class="list-bottom">
        <div class="list-bottom-box">
          <div class="bottom-box-name">订单类型</div>
          <div class="bottom-box-value">
            {{ detail?.orderType || "-" }}
          </div>
        </div>
        <div class="list-bottom-box">
          <div class="bottom-box-name">运费</div>
          <div class="bottom-box-value color526bec">
            ￥{{ detail?.fee }}
          </div>
        </div>
        <div class="list-bottom-box">
          <div class="bottom-box-name">技术服务费</div>
          <div class="bottom-box-value color526bec">
            ￥{{ detail?.technicalFee }}
          </div>
        </div>
        <div class="list-bottom-box">
          <div class="bottom-box-name">订金</div>
          <div class="bottom-box-value" >
            <span class="color526bec">￥{{ detail?.deposit }}</span>{{detail.canRefund?'（可退）':'（不可退）'}}
          </div>
        </div>
        <div class="list-bottom-box list-bottom-box4">
          <div class="bottom-box-name">订单编号</div>
          <div class="bottom-box-value">
            <custom-tooltip :text="detail?.sourceOrderNo"></custom-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomTooltip from "@/components/CustomTooltip.vue";

import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "DriverTemplate",
  components: { CustomTooltip },
  props: {
    detail: {
      type: Object,
      default: () =>{
        return {}
      }
    }
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
    }
  },
  methods: {
    getLocalLabel
  }
}
</script>

<style scoped lang="scss">
.third-order-template {
  width: 100%;
  .title-box {
    padding: 0.2rem 0 0;
  }
  .list-box {
    background: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.08rem 0;
      box-sizing: border-box;
      .list-bottom-box {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        box-sizing: border-box;
        .list-image {
          width: 0.6rem;
          height: 0.6rem;
          border-radius: 0.05rem;
        }
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.06rem;
        }
        .bottom-box-value {
          color: #434343;
          font-size: 0.14rem;
          text-align: center;
        }
      }
      .list-bottom-box3 {
        width: 40%;
        align-items: flex-start;
        padding-left: 5%;
        box-sizing: border-box;
      }
      .list-bottom-box2 {
        width: 20%;
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.06rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
      .list-bottom-box4 {
        width: 35%;
      }
      .list-bottom-box5 {
        width: 10%;
      }
    }
    //.list-bottom2 {
    //  .list-bottom-box:nth-last-of-type(1):before,
    //  .list-bottom-box:nth-last-of-type(2):before,
    //  .list-bottom-box:nth-last-of-type(3):before,
    //  .list-bottom-box:nth-last-of-type(4):before {
    //    display: none;
    //  }
    //}
  }
  .siji-image,
  .ding-image {
    width: 0.2rem;
    height: 0.2rem;
  }
}
</style>
